import { jsx as _jsx } from "react/jsx-runtime";
import I18n from "@geome/intl/lib/i18n";
import { createContext, useContext, useMemo } from "react";
import { I18nContext } from ".";
import { ConfigContext } from "../config";
export const I18nOptionsContext = createContext({});
export const I18nContextProvider = ({ children, intlData = { messages: {}, formats: undefined }, mode = "production", locale, formatHelpers = [], intlExplorer = false, logError, }) => {
    const i18n = useMemo(() => {
        const i18n = new I18n({ explorer: intlExplorer, logError });
        i18n.setIntlData(intlData);
        formatHelpers.forEach((fH) => i18n.registerFormatHelper(fH));
        i18n.setMode(mode);
        if (locale)
            i18n.setLocale(locale);
        return i18n;
    }, [intlData, mode, locale, formatHelpers]);
    return (_jsx(I18nOptionsContext.Provider, { value: { intlData, mode, locale, formatHelpers, intlExplorer, logError }, children: _jsx(I18nContext.Provider, { value: i18n, children: children }) }));
};
/**
 * Prefer ConfigContextProvider + I18nContextProvider - this function will soon be deprecated
 */
export const I18nContextProviderFromConfig = (props) => {
    const { intlData, locale, intlExplorer } = useContext(ConfigContext);
    return (_jsx(I18nOptionsContext.Provider, { value: { intlData, locale, intlExplorer, ...props }, children: _jsx(I18nContextProvider, { ...props, intlData: intlData, locale: locale, intlExplorer: intlExplorer }) }));
};
export const SubI18nContextProvider = ({ children, intlData: subIntlData, mode: subMode, locale: subLocale, formatHelpers: subFormatHelpers, intlExplorer: subIntlExplorer, logError: subLogError, }) => {
    const parentOptions = useContext(I18nOptionsContext);
    const mode = subMode ?? parentOptions.mode ?? "production";
    const intlData = subIntlData ?? parentOptions.intlData ?? { messages: {}, formats: undefined };
    const locale = subLocale ?? parentOptions.locale;
    const formatHelpers = subFormatHelpers ?? parentOptions.formatHelpers ?? [];
    const intlExplorer = subIntlExplorer ?? parentOptions.intlExplorer;
    const logError = subLogError ?? parentOptions.logError;
    const subI18n = useMemo(() => {
        const i18n = new I18n({ explorer: intlExplorer, logError });
        i18n.setIntlData(intlData);
        formatHelpers.forEach((fH) => i18n.registerFormatHelper(fH));
        i18n.setMode(mode);
        if (locale)
            i18n.setLocale(locale);
        return i18n;
    }, [intlData, mode, locale, formatHelpers]);
    return (_jsx(I18nOptionsContext.Provider, { value: { intlData, mode, locale, formatHelpers, intlExplorer, logError }, children: _jsx(I18nContext.Provider, { value: subI18n, children: children }) }));
};
